import { cn } from "@/components/podkit/lib/cn";
import { GripVertical } from "lucide-react";
import * as ResizablePrimitive from "react-resizable-panels";

export const ResizablePanelGroup = ({
    className,
    ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelGroup>) => (
    <ResizablePrimitive.PanelGroup
        className={cn("flex h-full w-full data-[panel-group-direction=vertical]:flex-col", className)}
        {...props}
    />
);

/**
 * This is a pixel based resizable element and is a wrapper around the `ResizablePrimitive.Panel` component.
 * If you need a pixel-based resizable element, use the {@link Resizable} component instead.
 */
export const ResizablePanel = ResizablePrimitive.Panel;

export const ResizableHandle = ({
    withHandle,
    className,
    ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelResizeHandle> & {
    withHandle?: boolean;
}) => (
    <ResizablePrimitive.PanelResizeHandle
        className={cn(
            "bg-border focus-visible:ring-ring relative flex items-center justify-center after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-offset-1 data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:left-0 data-[panel-group-direction=vertical]:after:h-1 data-[panel-group-direction=vertical]:after:w-full data-[panel-group-direction=vertical]:after:-translate-y-1/2 data-[panel-group-direction=vertical]:after:translate-x-0 [&[data-panel-group-direction=vertical]>div]:rotate-90",
            "-mr-1 w-1",
            "transition-colors duration-150 hover:bg-surface-03 active:bg-surface-04",
            className,
        )}
        {...props}
    >
        {withHandle && (
            <div className="bg-border z-10 flex h-4 w-3 items-center justify-center rounded-sm border">
                <GripVertical className="h-2.5 w-2.5" />
            </div>
        )}
    </ResizablePrimitive.PanelResizeHandle>
);
